<template>
  <div class="benefit-page">
    <BenefitHeader />
    <div class="tw:h-2 tw:bg-[#f5f6f8]" />
    <BenefitIndex
      :event-sections="eventSections"
      :event-banners="bannerList?.carousels ?? []"
      @click-event-item="clickEventItem"
    />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  middleware: ['naver-ads', 'kakao-pixel']
})

useHead({
  title: '혜택',
  meta: [],
  bodyAttrs: {
    'data-page-id': 'benefit'
  }
})

const { getEventSections } = useApi().eventApi
const { isApp } = useAppCheck()

const { data: eventSections } = await useAsyncData('sections', getEventSections, {
  transform: (res) => res.data.eventSections
})

const clickEventItem = (item: EventItem) => {
  const eventPage = `/benefit/${item.eventId}`
  navigateTo(eventPage)
}

const { data: bannerList, pending, refresh, error } = await useBannerList()
</script>
